import { toJS, observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api";
const { operate } = api;

class PurchaseOperateStore {
  // 获取运营列表
  // 1轮播2主推广告3顶部广告4通用楼层5搜索热词6频道
  @observable operateList = {
    // list: [{},{},{},{}],
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };

  @action async getOperateList(params) {
    let _data;
    console.log(params, "-----");
    switch (params.pageType) {
      case 1:
        _data = await httpClient.post(operate.GET_PURCHASE_HOME_BANNER_LIST, {
          ...params,
        });
        break;
      case 2:
        _data = await httpClient.post(
          operate.GET_PURCHASE_HOME_MAIN_ADVERT_LIST,
          { ...params }
        );
        break;
      case 3:
        _data = await httpClient.post(
          operate.GET_PURCHASE_HOME_TOP_ADVERT_LIST,
          { ...params }
        );
        break;
      case 4:
        _data = await httpClient.post(operate.GET_PURCHASE_HOME_FLOOR_LIST, {
          ...params,
        });
        break;
      case 5:
        _data = await httpClient.post(operate.GET_PURCHASE_HOME_HOT_WORD_LIST, {
          ...params,
        });
        break;
      case 6:
        _data = await httpClient.get(operate.GET_PURCHASE_HOME_CHANNEL_LIST, {
          params,
        });
        break;
      case 9:
        _data = await httpClient.post(
          operate.GET_PURCHASE_HOME_FLOOR_MOBILE_LIST,
          { ...params }
        );
        break;
      default:
        break;
    }

    const { data } = _data;
    if (data) {
      this.operateList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 重置列表
  @action resetOperateList() {
    this.operateList = {
      list: [],
      pages: {
        total: 0,
        pageSize: 20,
        currentPage: 1,
      },
    };
  }

  // 获取列表显示状态的数量
  @observable operateOnShowNum = 0;
  @action async getOperateOnShowNum(params) {
    let _data;
    console.log(params);
    switch (params.adType) {
      case 5:
        _data = await httpClient.post(
          operate.GET_PURCHASE_HOME_OPERATE_WORDS_SHOW_NUMBER,
          { ...params }
        );
        break;
      case 6:
        _data = await httpClient.get(
          operate.GET_PURCHASE_HOME_OPERATE_CHANNEL_SHOW_NUMBER,
          { params }
        );
        break;
      case 9:
        _data = await httpClient.post(
          operate.GET_PURCHASE_HOME_FLOOR_MOBILE_SHOW_NUMBER,
          { ...params }
        );
        break;
      default:
        _data = await httpClient.post(
          operate.GET_PURCHASE_HOME_OPERATE_SHOW_NUMBER,
          { ...params }
        );
        break;
    }
    this.operateOnShowNum =
      params.adType !== 9 ? _data.data : _data.data.currentShowNumber;
  }

  // 更改排序的序号，
  @action changeOperateSortNumber(params) {
    switch (params.pageType) {
      case 1:
        httpClient.post(operate.CHANGE_PURCHASE_HOME_BANNER_SORT, {
          ...params,
        });
        break;
      case 2:
        httpClient.post(operate.CHANGE_PURCHASE_HOME_MAIN_ADVERT_SORT, {
          ...params,
        });
        break;
      case 5:
        httpClient.post(operate.CHANGE_PURCHASE_HOME_HOT_WORD_SORT, {
          ...params,
        });
        break;
      case 6:
        httpClient.post(operate.CHANGE_PURCHASE_HOME_CHANNEL_SORT, {
          ...params,
        });
        break;
      case 9: {
        delete params.pageType;
        httpClient.post(operate.SET_PURCHASE_HOME_FLOOR_MOBILE_SORT, {
          ...params,
        });
        break;
      }
      default:
        break;
    }
  }

  // 更改独立运营页楼层排序，
  @action async changeIndependentFloorSort(params) {
    try {
      const { success } = await httpClient.post(operate.UPDATE_FLOOR_SORT, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 删除/隐藏/显示信息。1展示 2隐藏 3删除
  @action async delOperate(params) {
    switch (params.pageType) {
      case 1:
        httpClient.post(operate.DEL_PURCHASE_HOME_BANNER, { ...params });
        break;
      case 2:
        httpClient.post(operate.DEL_PURCHASE_HOME_MAIN_ADVERT, { ...params });
        break;
      case 3:
        httpClient.post(operate.DEL_PURCHASE_HOME_TOP_ADVERT, { ...params });
        break;
      case 4:
        httpClient.post(operate.DEL_PURCHASE_HOME_FLOOR, { ...params });
        break;
      case 5:
        httpClient.post(operate.DEL_PURCHASE_HOME_HOT_WORD, { ...params });
        break;
      case 6:
        httpClient.post(operate.DEL_PURCHASE_HOME_CHANNEL, {
          ...params,
          status: params.targetStatus,
        });
        break;
      case 8:
        httpClient.post(operate.DEL_PURCHASE_HOME_CHANNEL, {
          ...params,
          status: params.targetStatus,
        });
        break;
      case 9:
        httpClient.post(operate.SET_PURCHASE_HOME_FLOOR_MOBILE_STATUS, {
          ...params,
        });
        break;
      default:
        break;
    }
  }

  // 添加&编辑，首页运营
  @action async editOperate(params) {
    console.log(params);
    switch (params.pageType) {
      case 1:
        return httpClient.post(operate.EDIT_PURCHASE_HOME_BANNER, {
          ...params,
        });
        break;
      case 2:
        return httpClient.post(operate.EDIT_PURCHASE_HOME_MAIN_ADVERT, {
          ...params,
        });
        break;
      case 3:
        return httpClient.post(operate.EDIT_PURCHASE_HOME_TOP_ADVERT, {
          ...params,
        });
        break;
      case 4:
        return httpClient.post(operate.EDIT_PURCHASE_HOME_FLOOR, { ...params });
        break;
      case 5:
        return httpClient.post(operate.EDIT_PURCHASE_HOME_HOT_WORD, {
          ...params,
        });
        break;
      case 6:
        this.editChannel(params);
        break;
      default:
        break;
    }
  }
  @action editChannel(params) {
    return params.id
      ? httpClient.post(operate.EDIT_PURCHASE_HOME_CHANNEL, { ...params })
      : httpClient.post(operate.ADD_PURCHASE_HOME_CHANNEL, { ...params });
  }

  // 获取首页排序列表
  @observable operateSortList = [];
  @action async getOperateSortList(params) {
    const { data } = await httpClient.get(
      operate.GET_PURCHASE_HOME_FLOOR_SORT_LIST,
      { params }
    );
    if (data) {
      // this.operateSortList = [{ id: "1", name: "shrek" }, { id: "2", name: "222" }, { id: "3", name: "333" }, { id: "44", name: "333444" }]
      this.operateSortList = data;
    }
  }
  // 更改首页排序列表
  @action async changeOperateSortList(params) {
    await httpClient.post(operate.CHANGE_PURCHASE_HOME_FLOOR_SORT, {
      ...params,
    });
  }

  // 获取主推广告名称
  @observable operateMainAdvertInfo = {};
  @action async getMainAdvertInfo(params) {
    const { data } = await httpClient.get(
      operate.GET_PURCHASE_HOME_MAIN_ADVERT_INFO,
      { params }
    );
    this.operateMainAdvertInfo = data;
  }

  // 设置主推广告名称
  @action setMainAdvertInfo(params) {
    return httpClient.post(operate.SET_PURCHASE_HOME_MAIN_ADVERT_INFO, {
      ...params,
    });
  }

  // 获取首页运营详情
  @observable homeOperateDetailInfo = {};
  @action async getHomeOperateDetail(params) {
    let _data;
    switch (params.pageType) {
      case 6:
        _data = await httpClient.get(operate.GET_PURCHASE_HOME_CHANNEL_DETAIL, {
          params,
        });
        break;
      default:
        _data = await httpClient.get(operate.GET_PURCHASE_HOME_BANNER_DETAIL, {
          params,
        });
        break;
    }
    if (_data) {
      this.homeOperateDetailInfo = _data.data;
    }
  }

  @action async resetHomeOperateDetail(params) {
    this.homeOperateDetailInfo = {};
  }

  // 楼层
  // 获取楼层详情,所有楼层共用
  @action async getFloorDetail(params) {
    let _data;
    params.actKey === 9
      ? (_data = await httpClient.get(
          operate.GET_MOBILE_PURCHASE_HOME_FLOOR_DETAIL,
          { params }
        ))
      : (_data = await httpClient.get(operate.GET_PURCHASE_HOME_FLOOR_DETAIL, {
          params,
        }));

    if (_data) {
      this.homeOperateDetailInfo = _data.data;
    }
  }
  // //获取手机端楼层详情
  // @action async getMobileFloorDetail(params) {
  //   const { data } = await httpClient.get(operate.GET_MOBILE_PURCHASE_HOME_FLOOR_DETAIL, {params})
  //   this.homeOperateDetailInfo = data
  // }

  // 首页运营-添加楼层, 1广告2商品
  @action async addFloorOperate(params) {
    let _data;
    if (params.actKey == 9) {
      _data = await this.addMobileFloorOperate(params);
      return _data;
    } else {
      switch (params.type) {
        case 1:
          _data = await httpClient.post(operate.ADD_PURCHASE_HOME_AD_FLOOR, {
            ...params,
          });
          break;
        case 2:
          _data = await httpClient.post(
            operate.ADD_PURCHASE_HOME_SHOP_FLOOR,
            {}
          );
          break;
        default:
          break;
      }
      return _data.data;
    }
  }
  // 首页运营-手机独立区-添加楼层, 1广告2商品3活动
  @action async addMobileFloorOperate(params) {
    let _data;
    switch (params.type) {
      case 1:
        _data = await httpClient.post(
          operate.ADD_PURCHASE_OPERATE_AD_FLOOR_MOBILE,
          { ...params }
        );
        break;
      case 2:
        _data = await httpClient.post(
          operate.ADD_PURCHASE_OPERATE_SHOP_FLOOR_MOBILE,
          {}
        );
        break;
      case 3:
        _data = await httpClient.post(
          operate.ADD_PURCHASE_OPERATE_ACT_FLOOR_MOBILE,
          { activityType: params.actVal }
        );
        break;
      default:
        break;
    }
    return _data.data;
  }

  // 设置楼层简介-描述
  @action editFloorHeader(params) {
    return params.actKey == 9
      ? httpClient.post(operate.EDIT_MOBILE_OPERATE_FLOOR_INTRO, { ...params })
      : params.from === "IndependOperate"
      ? httpClient.post(operate.EDIT_INDEPEND_OPERATE_FLOOR_INTRO, {
          ...params,
        })
      : httpClient.post(operate.EDIT_PURCHASE_HOME_FLOOR_INTRO, { ...params });
  }

  // //设置手机楼层简介-描述
  // @action editMobileFloorHeader(params) {
  //   return httpClient.post(operate.EDIT_MOBILE_OPERATE_FLOOR_INTRO, {...params})
  // }

  // 商品楼层-添加/删除/排序
  @action addGoodsToShopFloor(params) {
    return params.actKey == 9
      ? httpClient.post(operate.ADD_MOBILE_GOODS_TO_SHOP_FLOOR, { ...params })
      : params.from === "IndependOperate"
      ? httpClient.post(operate.ADD_GOODS_TO_INDEPEND_OPERATE_SHOP_FLOOR, {
          ...params,
        })
      : httpClient.post(operate.ADD_GOODS_TO_SHOP_FLOOR, { ...params });
  }
  // @action addMobileGoodsToShopFloor(params) {
  //   return httpClient.post(operate.ADD_MOBILE_GOODS_TO_SHOP_FLOOR, {...params})
  // }
  @action addSpecialToSpecialFloor(params) {
    return httpClient.post(operate.ADD_SPECIAL_TO_SPECIAL_FLOOR, params);
  }
  @action delGoodsToShopFloor(params) {
    return params.from === "IndependOperate"
      ? httpClient.post(operate.DEL_GOODS_TO_INDEPEND_OPERATE_SHOP_FLOOR, {
          ...params,
        })
      : httpClient.post(operate.DEL_GOODS_TO_SHOP_FLOOR, { ...params });
  }

  @action delSpecialToSpecialFloor(params) {
    return httpClient.post(operate.DEL_SPECIAL_TO_SPECIAL_FLOOR, { ...params });
  }
  @action changeShopFloorGoodsSort(params) {
    return params.from === "IndependOperate"
      ? httpClient.post(operate.CHANGE_INDEPEND_OPERATE_SHOP_FLOOR_GOODS_SORT, {
          ...params,
        })
      : httpClient.post(operate.CHANGE_SHOP_FLOOR_GOODS_SORT, { ...params });
  }

  // 广告楼层
  @action setAdvertFloorDetail(params) {
    return params.actKey === 9
      ? httpClient.post(operate.EDIT_MOBILE_ADVERT_FLOOR_DETAIL, { ...params })
      : params.from === "IndependOperate"
      ? httpClient.post(operate.EDIT_INDEPEND_OPERATE_ADVERT_FLOOR_DETAIL, {
          ...params,
        })
      : httpClient.post(operate.EDIT_ADVERT_FLOOR_DETAIL, { ...params });
  }
  // // 广告楼层 -- 手机
  // @action setMobileAdvertFloorDetail(params) {
  //   return httpClient.post(operate.EDIT_MOBILE_ADVERT_FLOOR_DETAIL, {...params})
  // }

  // 获取独立运营-楼层列表
  @action async getIndependOperateFloorList(params) {
    const { data } = await httpClient.post(
      operate.GET_INDEPEND_OPERATE_FLOOR_LIST,
      { ...params }
    );
    if (data) {
      this.operateList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }
  // 独立运营-添加楼层, 1广告2商品
  @action async addIndependFloorOperate(params) {
    let _data;
    switch (params.type) {
      case 1:
        _data = await httpClient.post(operate.ADD_INDEPEND_OPERATE_AD_FLOOR, {
          ...params,
        });
        break;
      case 2:
        _data = await httpClient.post(operate.ADD_INDEPEND_OPERATE_SHOP_FLOOR, {
          ...params,
        });
        break;
      default:
        break;
    }
    return _data.data;
  }
  // 独立运营-删除/隐藏/显示信息。1展示 2隐藏 3删除
  @action delIndependFloorOperate(params) {
    return httpClient.post(operate.DEL_INDEPEND_OPERATE_FLOOR, { ...params });
  }

  // 获取独立运营页列表
  @observable independOperateList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1,
    },
  };
  @action async getIndependOperateList(params) {
    const { data } = await httpClient.post(operate.GET_INDEPEND_OPERATE_LIST, {
      ...params,
    });
    if (data) {
      this.independOperateList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page,
        },
      };
    }
  }

  // 添加&编辑，独立运营页
  @action async editIndependOperate(params) {
    return params.isAdd
      ? httpClient.post(operate.ADD_INDEPEND_OPERATE, { ...params })
      : httpClient.post(operate.EDIT_INDEPEND_OPERATE, { ...params });
  }

  // 删除独立运营页
  @action async delIndependOperate(params) {
    return httpClient.get(operate.DEL_INDEPEND_OPERATE, { params });
  }

  // 工作台首页-获取工作台首页详情
  @action async getWorkBenchDetail(params) {
    const { data } = await httpClient.get(operate.GET_WORK_BENCH_HOME_DETAIL, {
      params,
    });
    if (data) {
      this.homeOperateDetailInfo = data;
    }
    //  else {
    //   this.homeOperateDetailInfo = {
    //     floorElementList: [{}]
    //   }
    // }
  }
  // 工作台首页-设置布局
  @action async setWorkBenchLayout(params) {
    await httpClient.post(operate.SET_WORK_BENCH_LAYOUT, { ...params });
  }
  // 工作台首页-设置广告详情
  @action setWorkBenchDetail(params) {
    return httpClient.post(operate.EDIT_WORK_BENCH_HOME_DETAIL, { ...params });
  }

  // @action async addAdFloor(params) {
  //   const { data } = await httpClient.post(operate.ADD_AD_FLOOR,{ ...params })
  //   return data
  // }

  // @action async addShopFloor() {
  //   await httpClient.post(operate.ADD_SHOP_FLOOR)
  // }

  // 精选tab-获取当前配置
  @action async getSelectConfig() {
    const { data = {} } = await httpClient.get(operate.GET_SELECT_CONFIG, {});

    return data;
  }

  // 精选tab-修改当前配置
  @action async updateSelectConfig(params) {
    const { success } = await httpClient.post(operate.UPDATE_SELECT_CONFIG, {
      ...params,
    });
    return success;
  }

  // 价格设置
  // 获取价格区间列表
  @action async getPriceRangeList(params) {
    try {
      const { data } = await httpClient.post(operate.GET_PRICE_RANGE_LIST, {
        ...params,
      });
      return data;
    } catch (error) {
      return false;
    }
  }

  // 获取价格区间展示数量
  @action async getPriceRangeShowCount() {
    try {
      const { data } = await httpClient.get(
        operate.GET_PRICE_RANGE_SHOW_COUNT,
        {}
      );
      return data;
    } catch (error) {
      return false;
    }
  }

  // 添加价格区间
  @action async addPriceRange(params) {
    try {
      const { success } = await httpClient.post(operate.ADD_PRICE_RANGE, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 删除价格区间
  @action async delPriceRange(params) {
    try {
      const { success } = await httpClient.post(operate.DELETE_PRICE_RANGE, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  // 改变价格区间展示状态
  @action async changeShowStatus(params) {
    try {
      const { success } = await httpClient.post(
        operate.UPDATE_PRICE_RANGE_STATUS,
        { ...params }
      );
      return success;
    } catch (error) {
      return false;
    }
  }

  // 改变价格区间展示状态
  @action async changePriceRangeSort(params) {
    try {
      const { success } = await httpClient.post(
        operate.UPDATE_PRICE_RANGE_SORT,
        { ...params }
      );
      return success;
    } catch (error) {
      return false;
    }
  }

  // 获取热搜价格列表
  @action async getPriceHotList() {
    try {
      const { data } = await httpClient.get(operate.GET_PRICE_HOT_LIST, {});
      return data;
    } catch (error) {
      return false;
    }
  }

  // 修改热搜价格列表
  @action async updateHotPrice(params) {
    try {
      const { success } = await httpClient.post(operate.UPDATE_PRICE_HOT_LIST, {
        ...params,
      });
      return success;
    } catch (error) {
      return false;
    }
  }

  //添加独立运营页的主题楼层
  @action async addFloorIndepend(params) {
    try {
      const data = await httpClient.post(operate.ADD_FLOOR_INDEPEND, {
        ...params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }

  //添加首页的主题楼层
  @action async addFloorHome(params) {
    try {
      const data = await httpClient.post(operate.ADD_FLOOR_HOME, {
        ...params,
      });
      return data;
    } catch (err) {
      return err;
    }
  }
}

export default new PurchaseOperateStore();
